// Bugsnag
import bugsnag from './modules/bugsnag.js'

bugsnag()

// Dependencies
import AnchorLinksToggle from './modules/anchor-links-toggle.js'
import AudioPlayer from './modules/audio-player.js'
import ClipboardCopy from './modules/clipboard-copy.js'
import FormPost from './modules/form-post.js'
import FormValidate from './modules/form-validate.js'
import Glider from './modules/glider.js'
import Listing from './modules/listing.js'
import Menu from './modules/menu.js'
import Modal from './modules/modal.js'
import Search from './modules/search.js'
import Share from './modules/share.js'
import SimpleFilter from './modules/simple-filter.js'
import Sticky from './modules/sticky.js'
import SwiperSlider from './modules/swiper-slider.js'
import Tabs from './modules/tabs.js'
import ToggleClass from './modules/toggle-class.js'
import Tooltip from './modules/tooltip.js'
import TriggerTooltip from './modules/trigger-tooltip.js'
import Video from './modules/video.js'
import Video404 from './modules/video-404.js'
import hamburger from './modules/hamburger.js'
import headerSearch from './modules/header-search.js'
import responsiveTables from './modules/responsive-tables.js'
import {_, makeGtmCall} from './utils.js'
import ActiveCampaign from './modules/active-campaign.js'
import LocationMaps from './modules/location-maps.js'
import AiAgent from './modules/ai-agent.js'
import AiChallenges from './modules/ai-challenges.js'
import AiPrompt, { bindAgentTriggers } from './modules/ai-prompt.js'

responsiveTables()

// prettier-ignore
{
    _('', 'validate').nodes().forEach((el) => new FormValidate(el))
    _('anchor-links-toggle').nodes().forEach((el) => new AnchorLinksToggle(el))
    _('audio-player').nodes().forEach((el) => new AudioPlayer(el))
    _('clipboard-copy').nodes().forEach((el) => new ClipboardCopy(el))
    _('form-post').nodes().forEach((el) => new FormPost(el))
    _('glider').nodes().forEach((el) => new Glider(el))
    _('hamburger').nodes().forEach((el) => hamburger(el))
    _('listing').nodes().forEach((el) => new Listing(el))
    _('menu').nodes().forEach((el) => new Menu(el))
    _('modal').nodes().forEach((el) => new Modal(el))
    _('search').nodes().forEach((el) => new Search(el))
    _('share').nodes().forEach((el) => new Share(el))
    _('simpleFilterContainer').nodes().forEach((el) => new SimpleFilter(el))
    _('sticky').nodes().forEach((el) => new Sticky(el))
    _('swiperSlider').nodes().forEach((el) => new SwiperSlider(el))
    _('location-maps').nodes().forEach((el) => new LocationMaps(el))
    _('tab-trigger').nodes().forEach((el) => new Tabs(el))
    _('tippy').nodes().forEach((el) => new Tooltip(el))
    _('toggle-class').nodes().forEach((el) => new ToggleClass(el))
    _('togglesearch').nodes().map((el) => headerSearch.searchToggle(el))
    _('trigger-tippy').nodes().forEach((el) => new TriggerTooltip(el))
    _('video', 'element').nodes().forEach((el) => new Video(el))
    _('video-404').nodes().forEach((el) => new Video404(el))
    _('active-campaign').nodes().forEach((el) => new ActiveCampaign(el))
    _('ai-prompt').nodes().forEach((el) => new AiPrompt(el))
    _('ai-agent').nodes().forEach((el) => new AiAgent(el))
    _('ai-challenges').nodes().forEach((el) => new AiChallenges(el))
}

bindAgentTriggers()

headerSearch.trackSearch()

_('gtm-click')
    .nodes()
    .map((el) => {
        el.dataset.enabled = el.dataset.enabled || 'false'
        if (el.dataset.enabled === 'true') {
            return false
        }
        el.dataset.enabled = 'true'
        el.addEventListener('click', () => {
            makeGtmCall(el)
        })
    })
